<template>
    <div class="login_info no-trans" v-loading="loading">
        <div class="login_info_box">
            <div class="top_box">
                <img src="../../assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                 > 完善资料
            </div>
            <div class="bom_box">
                <div class="title_box">
                    <div class="borders"></div>
                    <div class="text1">完善资料</div>
                </div>
                <div class="form_box">
                    <div class="form_flex">
                        <div class="form_title">
                            <span>*</span>
                            选择身份
                        </div>
                        <div class="input1">
                            <el-select v-model="type_ac" placeholder="请选择">
                                <el-option
                                v-for="(item,index) in type_list"
                                :key="index"
                                :label="item.title"
                                :value="item.type" 
                                v-if="item.log_type==$route.query.log_type">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div v-if="type_ac==1">
                        <huiyuan ref="huiyuan"></huiyuan>
                    </div>
                    <div v-if="type_ac==2">
                        <ls_box ref="ls_box"></ls_box>
                    </div>
                    <div v-if="type_ac==3">
                        <falvzhuanjia ref="falvzhuanjia"></falvzhuanjia>
                    </div>
                    <div v-if="type_ac==4">
                        <flzgcyz ref="flzgcyz"></flzgcyz>
                    </div>
                    <div v-if="type_ac==5">
                        <gongshang ref="gongshang"></gongshang>
                    </div>
                    <div v-if="type_ac==6">
                        <lvsuo ref="lvsuo"></lvsuo>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import huiyuan from '@/components/login_info/huiyuan.vue'//会员
import ls_box from '@/components/login_info/lvshi.vue'//律师
import falvzhuanjia from '@/components/login_info/falvzhuanjia.vue'//法律专家
import flzgcyz from '@/components/login_info/flzgcyz.vue'//法律资格从业者
import gongshang from '@/components/login_info/gongshang.vue'//工商企业
import lvsuo from '@/components/login_info/lvsuo.vue'//律所



export default {
    components: {
        ls_box,
        huiyuan,
        falvzhuanjia,
        flzgcyz,
        gongshang,
        lvsuo,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            type_ac:1,

            type_list:[
                {
                    title:'普通会员',
                    type:1,
                    log_type:1,//1个人2企业
                },
                {
                    title:'律师',
                    type:2,
                    log_type:1,//1个人2企业
                },
                {
                    title:'法律专家',
                    type:3,
                    log_type:1,//1个人2企业
                },
                {
                    title:'法律资格从业者',
                    type:4,
                    log_type:1,//1个人2企业
                },
                {
                    title:'工商企业',
                    type:5,
                    log_type:2,//1个人2企业
                },
                {
                    title:'律所',
                    type:6,
                    log_type:2,//1个人2企业
                },

            ],
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        if(this.$route.query.log_type==2){
            this.type_ac=5
        }
    },
    methods: {
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        }



    },

}
</script>
<style scoped lang="less">
.login_info{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .login_info_box {
        width: 1440px;
        height: 100%;
        // background: #FFFFFF;
        margin: auto;
        .top_box{
            display: flex;        
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding-bottom: 22px;
            .span1{
                cursor: pointer;
            }
            img{
                width:14px ;
                height: 14px;
                margin-right: 10px;
            }
        }
        .bom_box{
            height: 100%;
            background: #FFFFFF;
            .title_box{
                display: flex;
                align-items: center;
                padding-top: 26px;
                padding-bottom: 42px;
                .borders{
                    width: 4px;
                    height: 22px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .text1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 20px;
                    color: #333333;
                    padding-left: 32px;
                }
            }
            .form_box{
                padding-left: 82px;
                // padding-right: 141px;
                .form_flex{
                    display: flex;
                    align-items: center;
                    padding-bottom: 24px;
                    .form_title{
                        width: 200px;
                        text-align: right;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        padding-right: 24px;
                        span{
                           color: #FD4C5C; 
                        }
                    }
                    .input1{
                        width: 400px;
                        height: 40px;
                        /deep/.el-select{
                            width: 400px;
                            height: 40px;
                        }

                    }
                }
            }
        }
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .login_info.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding: 16px;
        padding-bottom: 16px;
    }
    .login_info.no-trans .login_info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .login_info.no-trans .login_info_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding-bottom: 16px;
    }
    .login_info.no-trans .login_info_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .login_info.no-trans .login_info_box .bom_box .title_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .login_info.no-trans .login_info_box .bom_box .title_box .borders {
        width: 4px;
        height: 22px;
        border-radius: 3px 3px 3px 3px;
    }
    .login_info.no-trans .login_info_box .bom_box .title_box .text1 {
        font-size: 20px;
        padding-left: 16px;
    }
    .login_info.no-trans .login_info_box .bom_box .form_box {
        padding-left: 16px;
    }
    .login_info.no-trans .login_info_box .bom_box .form_box .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .login_info.no-trans .login_info_box .bom_box .form_box .form_flex .form_title {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 14px;
        padding-right: 16px;
        text-align: left;
        line-height: 1.6;
        padding: 0;
    }
    .login_info.no-trans .login_info_box .bom_box .form_box .form_flex .input1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
    .login_info.no-trans .login_info_box .bom_box .form_box .form_flex .input1 /deep/ .el-select {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
}
</style>
